<template>
  <router-link
    :to="{name: 'user_info', params: {userId: user.id}}"
  >
    {{user | getUserFullName}}
  </router-link>
</template>

<script>
export default {
  name: 'UserLink',

  props: {
    user: {
      type: Object,
      required: true,
    }
  },
};
</script>
